export const appTransactions = {
  name: 'App 交易 |||| App 交易',
  fields: {
    id: '交易編號',
    user_id: '用戶編號',
    amount: '金額',
    type: '類型',
    status: '狀態',
    payment_method: '付款方式',
    reference_id: '參考編號',
    description: '描述',
    metadata: '其他資料',
    created_at: '建立時間',
    updated_at: '更新時間',
    timestamp: '時間戳記',
    user: {
      name: '用戶名稱',
      email: '用戶電郵',
    },
  },
  types: {
    topup: '增值',
    deduction: '充電',
    pre_auth: '預授權',
    refund: '退款',
    reward: '獎勵',
    adjustment: '餘額調整',
    all: '所有類型',
  },
  statuses: {
    pending: '待處理',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
    hold: '保留',
    released: '已釋放',
    processing: '處理中',
    all: '所有狀態',
  },
  paymentMethods: {
    wallet: '錢包',
    credit_card: '信用卡',
    rfid: 'RFID',
    qr_code: '二維碼',
  },
  filters: {
    search: '搜尋',
    type: '交易類型',
    status: '狀態',
    from_date: '開始日期',
    to_date: '結束日期',
    min_amount: '最低金額',
    max_amount: '最高金額',
  },
  summary: {
    total_transactions: '交易總數',
    net_amount: '淨金額',
    completed: '已完成',
    pending_failed: '待處理 / 失敗',
  },
  actions: {
    export: '匯出 CSV',
    refresh: '重新整理',
  },
  messages: {
    exportSuccess: '交易匯出成功',
    exportFailed: '交易匯出失敗',
    refundSuccess: '退款處理成功',
    refundFailed: '退款處理失敗',
  },
  show: {
    title: '交易詳情',
    transactionInfo: '交易資訊',
    userInfo: '用戶資訊',
    paymentDetails: '付款詳情',
    chargingSessionDetails: '充電階段詳情',
    adminNotes: '管理員備註',
    transactionId: '交易編號',
    type: '類型',
    status: '狀態',
    amount: '金額',
    dateTime: '日期/時間',
    paymentMethod: '付款方式',
    referenceType: '參考類型',
    referenceId: '參考編號',
    userId: '用戶編號',
    name: '名稱',
    email: '電郵',
    sessionId: '階段編號',
    charger: '充電樁',
    site: '站點',
    energyDelivered: '已提供電量',
    startTime: '開始時間',
    endTime: '結束時間',
    duration: '時長',
    finalCost: '最終費用',
    inProgress: '進行中',
    minutes: '分鐘',
    processRefund: '處理退款',
    refundAmount: '退款金額',
    refundReason: '退款原因',
    maximum: '最高',
    cancel: '取消',
    refundWarning: '這將退款金額退回用戶的錢包餘額。',
  },
};
